import { createActions, createReducer } from "reduxsauce";
import selectLanguage from '../../helpers/selectLanguage';

//Action types e Creators
export const { Types, Creators } = createActions({
    change: ["language"],
    clear: [],
});

//Reducer Handlers
const initialState = {
    name: selectLanguage(navigator.language) || 'pt-br'
};

const change = (state = initialState, action) => {
    document.documentElement.lang = action.language;
    return { name: action.language }
};

const clear = (state = initialState) => {
    return initialState;
};

//Criando Reducer
export default createReducer(initialState, { 
    [Types.CHANGE]: change,
    [Types.CLEAR]: clear,
});
